import { MouseEvent, RefObject, useEffect } from "react"

export default function useOnOutsideClick(
  ref: RefObject<HTMLElement>,
  callback?: CallableFunction
) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent<HTMLElement>) {
      if (!ref.current?.contains(event.target as Node)) {
        callback && callback()
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside as any)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside as any)
    }
  }, [ref, callback])
}
